import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllCoolantColors =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'coolantColors', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/CoolantColors', { typeId })
            const coolantColors: SelectOptionLocal[] = []

            if (status === 'ok') {
                for (let i = 0; i < data.length; i++) {
                    const color = data[i]
                    if (color && color.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        coolantColors.push({ name: color, value: color })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllCoolantColors, value: { coolantColors } })
        } catch (e) {
            console.error('load coolantColors failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'coolantColors', value: false } })
    }

export default getAllCoolantColors
